export default __webpack_public_path__ + "static/media/team55.ccd63bfd.JPG";